export const resources = {
  SideBarCloseLabel: ''
};
